module.exports = {
  "based-cdn-hero": "https://static.basedcdn.com/basedcdn-demo/src/assets/based-cdn-hero.png",
  "heroimage": "https://static.basedcdn.com/basedcdn-demo/src/assets/heroimage.png",
  "codesnippet": "https://static.basedcdn.com/basedcdn-demo/src/assets/codesnippet.png"
};